import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "pdfTextTesterResult" ]

  connect() {
    console.log("Hello, PDF Text Tester Controller here!", this.element)
    this.pdfLib = window.pdfjsLib
    if (!this.pdfLib) {
      console.error("PDF.js library (window.pdfjsLib) is not loaded. Check the script tag on the page.")
    }
  }

  handleFileSelect(event) {
    console.log("handleFileSelect", event)

    const file = event.target.files[0]
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const arrayBuffer = e.target.result;

        if (!this.pdfLib) {
          throw new Error("PDF.js library is not available on window.pdfjsLib.")
        }

        // Load PDF from the ArrayBuffer (run without a separate worker to simplify bundling)
        const loadingTask = this.pdfLib.getDocument({
          data: arrayBuffer,
          disableWorker: true,
        });
        const pdf = await loadingTask.promise;

        // For this tester, just inspect the first page
        const page = await pdf.getPage(1);
        const textContent = await page.getTextContent();

        const hasText = textContent.items.some(
          (item) => item.str && item.str.trim().length > 0
        );

        console.log("PDF has text content?", hasText, textContent);

        if (this.hasPdfTextTesterResultTarget) {
          this.pdfTextTesterResultTarget.textContent = hasText
            ? "PDF appears to contain selectable text."
            : "PDF appears to be image-only (no text content detected).";
        }
      } catch (error) {
        console.error("Error while reading PDF with pdfjs-dist:", error);
        if (this.hasPdfTextTesterResultTarget) {
          const message =
            (error && (error.message || error.name)) ||
            "Unknown error while reading PDF.";

          this.pdfTextTesterResultTarget.textContent = `Error reading PDF: ${message}`;
        }
      }
    }

    reader.readAsArrayBuffer(file)
  }

}
